import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c470d278"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { getAltName, getDefaultBackgroundColor } from "@/utils/utilities";
import { computed } from "vue";
// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'avatar',
  props: {
  img: {
    type: String,
    required: false,
    default: "",
  },
  altName: {
    type: String,
    required: true,
    default: "avatar",
  },
  size: {
    type: Number,
    required: false,
    default: 30,
  },
},
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "2e818d58": (color.value)
}))



const color = computed(() => {
  return getDefaultBackgroundColor(props.altName)
    ? `${getDefaultBackgroundColor(props.altName)}`
    : "#E4F1FF";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.img)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(`width: ${__props.size}px; height: ${__props.size}px`),
          class: _normalizeClass(`tw-text-[#ffffff] tw-text-[10px] text-alt tw-items-center tw-rounded-[50%] tw-flex tw-justify-center`)
        }, _toDisplayString(_unref(getAltName)(__props.altName)), 5))
      : _createCommentVNode("", true),
    (__props.img)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: __props.img,
          class: "tw-rounded-[50%]",
          style: _normalizeStyle(`width: ${__props.size}px; height: ${__props.size}px`)
        }, null, 12, _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})